import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserData } from '../../redux/slices/userSlice';
import WelcomePage from './WelcomePage';
import OnboardingStep from './OnboardingStep';
import ProfileSetupPage from './ProfileSetupPage';

// Содержимое для каждого шага онбординга (пока без контента)
const stepsContent = [
    {
        title: "Добро пожаловать в Элитный Легион",
        description: "Здесь мы готовим новичков к тому, чтобы они стали сильными и уверенными пилотами, способными управлять командами и смело покорять «Футурион» — город будущего."
    },
    {
        title: "Как это работает?",
        description: "Вас ждут 20 увлекательных интерактивных уроков, которые можно сравнить с планетами на карте нашей системы. Каждый урок — это новый шаг к вашему мастерству. Выполняйте задания, проходите проверку с помощью ИИ-ассистента и получайте баллы за активность!"
    },
    {
        title: "Призы и достижения",
        description: "Накопленные баллы открывают доступ к подаркам, бонусам и секретным материалам. Здесь ценится не просто знание, а прогресс и стремление расти."
    },
    {
        title: "Готов к полету?",
        description: "Ваше путешествие начинается прямо сейчас!\n\n Пожалуйста, заполните свой профиль, чтобы мы могли выдать вам снаряжение пилота и назначить вашу первую миссию.",
    }
];

const OnboardingFlow = () => {
    const [currentStep, setCurrentStep] = useState(-1); // -1 для WelcomePage, 0-2 для шагов, 3 для профиля
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [direction, setDirection] = useState('next'); // 'next' или 'prev' для анимации
    const dispatch = useDispatch();
    const navigate = useNavigate(); // Хук для навигации

    // Обработка нажатия на кнопку "Далее"
    const handleNext = () => {
        if (currentStep < stepsContent.length) {
            setDirection('next');
            setIsTransitioning(true);

            setTimeout(() => {
                setCurrentStep(prev => prev + 1);
                setIsTransitioning(false);
            }, 300); // Время анимации
        }
    };

    // Обработка нажатия на кнопку "Назад"
    const handlePrev = () => {
        if (currentStep > -1) {
            setDirection('prev');
            setIsTransitioning(true);

            setTimeout(() => {
                setCurrentStep(prev => prev - 1);
                setIsTransitioning(false);
            }, 300); // Время анимации
        }
    };

    const handleComplete = (profileData) => {
        dispatch(setUserData({
            isNew: false,
            username: profileData.name
        }));

        navigate('/');
    };

    // Определение класса контейнера в зависимости от текущего состояния
    const containerClass = `onboarding-container ${isTransitioning ? `transitioning-${direction}` : ''}`;

    // Переход к определенному шагу (если нужно)
    const goToStep = (stepIndex) => {
        if (stepIndex >= -1 && stepIndex <= stepsContent.length) {
            // Определяем направление анимации
            const newDirection = stepIndex > currentStep ? 'next' : 'prev';
            setDirection(newDirection);
            setIsTransitioning(true);

            setTimeout(() => {
                setCurrentStep(stepIndex);
                setIsTransitioning(false);
            }, 300);
        }
    };

    return (
        <div className={containerClass}>
            {currentStep === -1 && (
                <WelcomePage onNext={handleNext} />
            )}

            {currentStep >= 0 && currentStep < stepsContent.length && (
                <div className="onboarding-step" key={`step-${currentStep}`}>
                    <OnboardingStep
                        content={stepsContent[currentStep]}
                        currentStep={currentStep}
                        totalSteps={stepsContent.length}
                        onNext={handleNext}
                        onPrev={handlePrev}
                        goToStep={goToStep}
                    />
                </div>
            )}

            {currentStep === stepsContent.length && (
                <div className="onboarding-step" key="profile">
                    <ProfileSetupPage
                        onComplete={handleComplete}
                        onPrev={handlePrev}
                    />
                </div>
            )}
        </div>
    );
};

export default OnboardingFlow; 